import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import ResumeTabs from '../../../components/employeemng/resume/ResumeTabs';

const ResumeTabsContainer = ({edit}) => {
  const { employee } = useSelector(({ empModule, loading }) => ({
    employee: empModule.employee.employee,
  }));

  //로딩 중이거나 아직 포스트가 없을때
  if (!employee) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <ResumeTabs employee={employee} edit={edit}/>;
};

export default ResumeTabsContainer;
